import { getSpecificPOData, updatePOStatus, sendActiveTab, updatePOSupplier } from '@/services/purchase-orders';
import router from '@/router/router';
import { Message, Loading } from 'element-ui';
import * as types from '../mutation-types';

const state = {
  purchaseOrder: {},
  poProductionStart: null,
  poHandedOverDate: null,
  poShippedDate: null,
};

const getters = {
  getPOItem: state => state.purchaseOrder,
  getPoProductionStart: (state) => {
    if (state.purchaseOrder.startDate) {
      return state.purchaseOrder.startDate;
    }
    return state.poProductionStart;
  },
  getPOUpdates: () => {
    const updates = [];
    // if (getters.getPOItem.updates && getters.getPOItem.updates.total > 0) {
    //   Object.keys(getters.getPOItem.updates.snapshot).map((key) => {
    //     if (state.purchaseOrder[key] !== state.purchaseOrder.updates.snapshot[key]) {
    //       if (typeof state.purchaseOrder[key] === 'string' || state.purchaseOrder[key] == null) {
    //         const keyObj = {};
    //         keyObj[key] = {
    //           prop: key,
    //           new: state.purchaseOrder[key],
    //           old: state.purchaseOrder.updates.snapshot[key],
    //         };
    //         return updates.push(keyObj);
    //       } else if (key === 'documents' || key === 'comments' || key === 'products') {
    //         let keyId;
    //         Object.keys(state.purchaseOrder[key]).map((a) => {
    //           keyId = state.purchaseOrder[key][a].id;
    //           return keyId;
    //         });
    //         if (state.purchaseOrder.updates.snapshot[key].indexOf(keyId) === -1) {
    //           const keyObj = {};
    //           keyObj[key] = [keyId];
    //           return updates.push(keyObj);
    //         }
    //       } else {
    //         Object.keys(state.purchaseOrder.updates.snapshot[key]).map((i) => {
    //           if (state.purchaseOrder[key][i] !== state.purchaseOrder.updates.snapshot[key][i]) {
    //             if (i !== 'id' && i !== 'purchaseOrder') {
    //               const keyObj = {};
    //               keyObj[key] = {
    //                 prop: i,
    //                 new: state.purchaseOrder[key][i],
    //                 old: state.purchaseOrder.updates.snapshot[key][i],
    //               };
    //               return updates.push(keyObj);
    //             }
    //           }
    //           return updates;
    //         });
    //       }
    //     }
    //     return updates;
    //   });
    // }
    return updates;
  },
  getPoProductionEnd: (state) => {
    if (state.purchaseOrder.endDate) {
      return state.purchaseOrder.endDate;
    }
    return state.poProductionEnd;
  },
  getHandedOverDate: (state) => {
    if (state.purchaseOrder.handedOverAt) {
      return state.purchaseOrder.handedOverAt;
    }
    return state.poHandedOverDate;
  },
  getPoShippedDate: (state) => {
    if (state.purchaseOrder.shippedAt) {
      return state.purchaseOrder.shippedAt;
    }
    return state.poShippedDate;
  },
};

const mutations = {
  [types.SET_PO_ITEM](state, purchaseOrder) {
    state.purchaseOrder = purchaseOrder;
  },
  [types.UPDATE_PO_STATUS](state, status) {
    if (status.startDate) {
      state.poProductionEnd = status.endDate;
      state.poProductionStart = status.startDate;
      state.purchaseOrder.startDate = status.startDate;
    } else if (status.blDate) {
      state.poHandedOverDate = status.blDate;
    } else {
      state.poShippedDate = status.shippedDate;
    }
  },
};

const actions = {
  setNewPoItem({ commit }, data) {
    commit(types.SET_PO_ITEM, data);
  },
  setPOItem({ commit }, info) {
    if (typeof info === 'object') {
      const tab = typeof info.tabInfo !== 'undefined' ? info.tabInfo : '';
      const id = info.id; //eslint-disable-line
      getSpecificPOData(id, tab).then(response => response.data).then((data) => {
        if (data.updates) {
          commit(types.SET_PO_UPDATES, data.updates);
        }
        return commit(types.SET_PO_ITEM, data);
      }).catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
        } else if (error.response.status === 404) {
          router.push('/404');
        } else {
          Message.error('Something went wrong! Try again.');
        }
      });
    } else {
      getSpecificPOData(info, '').then(response => response.data)
        .then(data => commit(types.SET_PO_ITEM, data)).catch((error) => {
          if (error.response.data.message) {
            Message.error(error.response.data.message);
          } else if (error.response.status === 404) {
            router.push('/404');
          } else {
            Message.error('Something went wrong! Try again.');
          }
        });
    }
  },
  createCustomerAddress({ commit }, addressObj) {
    const destinationLoading = Loading.service({
      target: '.destinationCardLoading',
      text: 'Loading...',
    });
    const requestObj = { customerAddress: { name: addressObj.destinationName } };
    updatePOStatus(addressObj.poId, requestObj).then(response => response.data)
      .then((data) => {
        commit(types.SET_PO_ITEM, data);
        destinationLoading.close();
        Message.success('Success! Destination updated.');
      }).catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
          destinationLoading.close();
        } else {
          Message.error('Something went wrong! Try again.');
          destinationLoading.close();
        }
      });
  },
  updateCustomerAddress({ commit }, addressObj) {
    const destinationLoading = Loading.service({
      target: '.destinationCardLoading',
      text: 'Loading...',
    });
    if (addressObj.destinationId) {
      const requestObj = { customerAddress: { id: addressObj.destinationId } };
      updatePOStatus(addressObj.poId, requestObj).then(response => response.data)
        .then((data) => {
          commit(types.SET_PO_ITEM, data);
          destinationLoading.close();
          Message.success('Success! Destination updated.');
        }).catch((error) => {
          if (error.response.data.message) {
            Message.error(error.response.data.message);
            destinationLoading.close();
          } else {
            Message.error('Something went wrong! Try again.');
          }
        });
    } else {
      const poId = addressObj.poId; //eslint-disable-line
      delete addressObj.poId; //eslint-disable-line
      const requestObj = { customerAddress: addressObj };
      updatePOStatus(poId, requestObj).then(response => response.data)
        .then((data) => {
          commit(types.SET_PO_ITEM, data);
          Message.success('Success! Destination updated.');
          destinationLoading.close();
        }).catch((error) => {
          if (error.response.data.message) {
            Message.error(error.response.data.message);
            destinationLoading.close();
          } else {
            Message.error('Something went wrong! Try again.');
            destinationLoading.close();
          }
        });
    }
  },
  updateSupplierAddress({ commit }, addressObj) {
    const supplierLoading = Loading.service({
      target: '.supplierCardLoading',
      text: 'Loading...',
    });
    if (addressObj.supplierId) {
      const requestObj = { supplier: addressObj.supplierId };
      updatePOSupplier(addressObj.poId, requestObj).then(response => response.data).then((data) => {
        commit(types.SET_PO_ITEM, data);
        supplierLoading.close();
        Message.success('Success! Supplier updated.');
      }).catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
          supplierLoading.close();
        } else {
          Message.error('Something went wrong! Try again.');
          supplierLoading.close();
        }
      });
    } else if (addressObj.supplierName) {
      const requestObj = { supplier: { name: addressObj.supplierName } };
      updatePOSupplier(addressObj.poId, requestObj).then(response => response.data).then((data) => {
        commit(types.SET_PO_ITEM, data);
        supplierLoading.close();
        Message.success('Success! Supplier updated.');
      }).catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
          supplierLoading.close();
        } else {
          Message.error('Something went wrong! Try again.');
          supplierLoading.close();
        }
      });
    } else {
      const poId = addressObj.poId; //eslint-disable-line
      delete addressObj.poId; //eslint-disable-line
      const requestObj = { supplierAddress: addressObj };
      updatePOSupplier(poId, requestObj).then(response => response.data).then((data) => {
        commit(types.SET_PO_ITEM, data);
        supplierLoading.close();
        Message.success('Success! Supplier updated.');
      }).catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
          supplierLoading.close();
        } else {
          Message.error('Something went wrong! Try again.');
          supplierLoading.close();
        }
      });
    }
  },
  updateStatus({ commit }, dateObj) {
    if (dateObj.endDate) {
      const estDateLoading = Loading.service({
        target: '.estEndDateCardLoading',
        text: 'Loading...',
      });

      let requestObj;
      if (dateObj.startDate) {
        requestObj = { startDate: dateObj.startDate, endDate: dateObj.endDate };
      } else {
        requestObj = { endDate: dateObj.endDate };
      }
      if (dateObj.dueDate) {
        if (dateObj.dueDate2) {
          requestObj.payment = {
            payments: [{ due: dateObj.dueDate }, { due: dateObj.dueDate2 }],
            observation: dateObj.paymentObservation,
          };
        } else {
          requestObj.payment = {
            payments: [{ due: dateObj.dueDate }],
            observation: dateObj.paymentObservation,
          };
        }
      }
      updatePOStatus(dateObj.poId, requestObj).then(response => response.data).then((data) => {
        commit(types.SET_PO_ITEM, data);
        commit(types.UPDATE_PO_STATUS, data.status);
        estDateLoading.close();
        Message.success('Success! PO updated.');
      }).catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
          estDateLoading.close();
        } else {
          estDateLoading.close();
          Message.error('Something went wrong! Try again.');
        }
      });
    } else if (dateObj.handedOverAt) {
      const handedOverDateLoading = Loading.service({
        target: '.handedOverDateCardLoading',
        text: 'Loading...',
      });
      const requestObj = { handedOverAt: dateObj.handedOverAt };
      updatePOStatus(dateObj.poId, requestObj).then(response => response.data).then((data) => {
        commit(types.SET_PO_ITEM, data);
        commit(types.UPDATE_PO_STATUS, data.status);
        handedOverDateLoading.close();
        Message.success('Success! PO updated.');
      }).catch((error) => {
        if (error.response.data.message) {
          handedOverDateLoading.close();
          Message.error(error.response.data.message);
        } else {
          handedOverDateLoading.close();
          Message.error('Something went wrong! Try again.');
        }
      });
    } else {
      const shippedDateLoading = Loading.service({
        target: '.shippedDateCardLoading',
        text: 'Loading...',
      });
      const requestObj = { shippedAt: dateObj.shippedAt };
      updatePOStatus(dateObj.poId, requestObj).then(response => response.data).then((data) => {
        commit(types.SET_PO_ITEM, data);
        commit(types.UPDATE_PO_STATUS, data.status);
        shippedDateLoading.close();
        Message.success('Success! PO updated.');
      }).catch((error) => {
        if (error.response.data.message) {
          shippedDateLoading.close();
          Message.error(error.response.data.message);
        } else {
          shippedDateLoading.close();
          Message.error('Something went wrong! Try again.');
        }
      });
    }
  },
  sendActiveTab(context, activeTab) {
    const poId = activeTab.id;
    const tabJSON = { tab: activeTab.name };
    sendActiveTab(poId, tabJSON).then(response => response.data).then(data => data).catch((error) => {
      console.error(error.response.data.message); //eslint-disable-line
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/purchase-order.js